import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";
import DashboardStatistics from "./DashboardStatistics";
import { ReactComponent as InfoSvg } from "assets/Svgs/InfoSvg.svg";
import { useEffect, useState } from "react";
import { kpisJSON } from "utils/kpisConfigs";

interface RenderKPIProps {
  appBarValue: any;
  siteData: any;
  showStatsExt?: boolean;
  activeEquipment: any;
  value: any;
  areaNodeIdsByIndex: any;
}
function RenderKPI(props: RenderKPIProps) {
  const lang = useBoundStore((state) => state.lang);
  const getKpisData: any = useBoundStore((state) => state.getKpisData);

  const [productTotalCount, setProductTotalCount] = useState<number>(0);
  const [rejectTotalCount, setRejectTotalCount] = useState<number>(0);
  const [detectorTestTotalCount, setDetectorTestTotalCount] =
    useState<number>(0);
  const [predMtTotalCount, setPredMtTotalCount] = useState<number>(0);

  const [productsTotal, setProductsTotal] = useState<any>({});
  const [rejectDetectionTotal, setRejectDetectionTotal] = useState<any>({});
  const [detectortest24h, setDetectortest24h] = useState<any>({});
  const [predMtTotal, setPredMtTotal] = useState<any>({});

  const [showPT, setShowPT] = useState(false);
  const [showRT, setShowRT] = useState(false);
  const [showDT, setShowDT] = useState(false);
  const [showPTRTRATIO, setShowPTRTRATIO] = useState(false);

  const [showSwitchingCylcles, setShowSwitchingCylcles] = useState(false);
  const [showRuntimedrivecomponents, setShowRuntimedrivecomponents] = useState(false);


  const getSingleEquipment = useBoundStore((state) => state.getSingleEquipment);

  const getObject = (model: string) => {
    let data = kpisJSON.filter(
      (kpi: any) =>
        kpi.model.toLowerCase() ===
        (model !== null ? model.toLowerCase() : model)
    );
    if (data.length) {
      let hasPTRTRATIO = data[0].kpis.filter(
        (kpi: any) => kpi.name === "ratiorejectdetectionvsproductstotal"
      );
      let hasPT = data[0].kpis.filter(
        (kpi: any) => kpi.name === "productstotal"
      );
      let hasRT = data[0].kpis.filter(
        (kpi: any) => kpi.name === "rejectdetectiontotal"
      );
      let hasDT24 = data[0].kpis.filter(
        (kpi: any) => kpi.name === "detectortests24h"
      );

      let hasSwitchingCycles = data[0].kpis.filter(
        (kpi: any) => kpi.name === "switchingcycles"
      );

      let hasRunTimeDerivedComponents = data[0].kpis.filter(
        (kpi: any) => kpi.name === "runtimedrivecomponents"
      );

      return {
        obj: data[0],
        hasPTRTRATIO: hasPTRTRATIO.length ? true : false,
        hasPT: hasPT.length ? true : false,
        hasRT: hasRT.length ? true : false,
        hasDT24: hasDT24.length ? true : false,
        hasSwitchingCycles : hasSwitchingCycles.length ? true : false,
        hasRunTimeDerivedComponents : hasRunTimeDerivedComponents.length ? true : false
      };
    } else {
      return false;
    }
  };

  useEffect(() => {
    // Calc the KPIs
    let productsTotal: any = {};
    let rejectDetectionTotal: any = {};
    let detectortest24h: any = {};
    let detectorTestsPassedTotal: any = {};

    for (const equipmentItem of getKpisData) {
      if (equipmentItem.equipment.haslivedata !== undefined) {
        const filteredEquipment = getSingleEquipment(
          equipmentItem.equipment.nodeid
        );
        for (const equipmentLivedataItem of equipmentItem.equipment
          .haslivedata) {
          const equipmentLivedata = equipmentLivedataItem.equipmentlivedata;

          let obj = getObject(
            filteredEquipment &&
              filteredEquipment.equipment.hasequipmenttype &&
              filteredEquipment.equipment.hasequipmenttype[0].equipmenttype
                .model
          );

          if (
            equipmentLivedata.productstotal !== undefined &&
            equipmentLivedata.productstotal.length &&
            obj !== false &&
            obj.hasPT
          ) {
            productsTotal[equipmentItem.equipment.nodeid] =
              equipmentLivedata.productstotal[0]._value;
          } else {
           
          }

          if (
            equipmentLivedata.rejectdetectiontotal !== undefined &&
            equipmentLivedata.rejectdetectiontotal.length &&
            obj !== false &&
            obj.hasRT
          ) {
            rejectDetectionTotal[equipmentItem.equipment.nodeid] =
              equipmentLivedata.rejectdetectiontotal[0]._value;
           
          } else {
           
          }

          if (
            equipmentLivedata.rejectdetectortestmanualtotal !== undefined &&
            equipmentLivedata.rejectdetectortestmanualtotal.length &&
            obj !== false &&
            obj.hasDT24
          ) {
            
          } else {
            
          }

          if (
            equipmentLivedata.detectortestspassedtotal !== undefined &&
            equipmentLivedata.detectortestspassedtotal.length &&
            obj !== false &&
            obj.hasDT24
          ) {
            detectortest24h[equipmentItem.equipment.nodeid] =
              equipmentLivedata.detectortestspassedtotal[0]._value;
            
          } else {
           
          }
          
        }
      }
    }

    setProductsTotal(productsTotal);
    setRejectDetectionTotal(rejectDetectionTotal);
    setDetectortest24h(detectortest24h);
  }, [getKpisData]);

  useEffect(() => {
    let prod_total_count = 0;
    let reject_total_count = 0;
    let detector_test_total_count = 0;
    let pred_total_count = 0;

    Object.keys(props.siteData).map((site: any, index: number) => {
      index === +props.appBarValue &&
        props.siteData[site]?.hasarea &&
        props.siteData[site]?.hasarea.map((area: any) => {
          if (
            props.value === 0 ||
            area.area.nodeid === props.areaNodeIdsByIndex[props.value]
          ) {
            
            area.area?.hasequipment &&
              area.area?.hasequipment.map((eq: any) => {
                if (props.activeEquipment === -1) {

                  //flags for boxes
                  let obj = getObject(
                    eq &&
                    eq.equipment.hasequipmenttype &&
                    eq.equipment.hasequipmenttype[0].equipmenttype
                        .model
                  );
        
                  if (
                    obj !== false &&
                    obj.hasPT
                  ) {
                    
                    setShowPT(true);
                  } else {
                    setShowPT(false);
                  }
        
                  if (
                    obj !== false &&
                    obj.hasRT
                  ) {
                    setShowRT(true);
                  } else {
                    setShowRT(false);
                  }
        
                  if (
                    obj !== false &&
                    obj.hasDT24
                  ) {
                    setShowDT(true);
                  } else {
                    setShowDT(false);
                  }

                  if (
                    obj !== false &&
                    obj.hasSwitchingCycles
                  ) {
                    setShowSwitchingCylcles(true);
                  } else {
                    setShowSwitchingCylcles(false);
                  }

                  if (
                    obj !== false &&
                    obj.hasRunTimeDerivedComponents
                  ) {
                    setShowRuntimedrivecomponents(true);
                  } else {
                    setShowRuntimedrivecomponents(false);
                  }

                  if (
                    obj !== false &&
                    obj.hasPTRTRATIO
                  ) {
                    setShowPTRTRATIO(true);
                  } else {
                    setShowPTRTRATIO(false);
                  }
                  //end



                  if (productsTotal[eq.equipment.nodeid]) {
                    prod_total_count += productsTotal[eq.equipment.nodeid];
                  }
                  if (rejectDetectionTotal[eq.equipment.nodeid]) {
                    reject_total_count +=
                      rejectDetectionTotal[eq.equipment.nodeid];
                  }
                  if (detectortest24h[eq.equipment.nodeid]) {
                    detector_test_total_count +=
                      detectortest24h[eq.equipment.nodeid];
                  }
                  if (predMtTotal[eq.equipment.nodeid]) {
                    pred_total_count += predMtTotal[eq.equipment.nodeid];
                  }
                } else {
                   //flags for boxes
                   if(eq.equipment.nodeid === props.activeEquipment) {
                    let obj = getObject(
                      eq &&
                      eq.equipment.hasequipmenttype &&
                      eq.equipment.hasequipmenttype[0].equipmenttype
                          .model
                    );
          
                    if (
                      obj !== false &&
                      obj.hasPT
                    ) {
                      
                      setShowPT(true);
                    } else {
                      setShowPT(false);
                    }
          
                    if (
                      
                      obj !== false &&
                      obj.hasRT
                    ) {
                      setShowRT(true);
                    } else {
                      setShowRT(false);
                    }
          
                    if (
                      
                      obj !== false &&
                      obj.hasDT24
                    ) {
                      setShowDT(true);
                    } else {
                      setShowDT(false);
                    }

                    if (
                      obj !== false &&
                      obj.hasSwitchingCycles
                    ) {
                      setShowSwitchingCylcles(true);
                    } else {
                      setShowSwitchingCylcles(false);
                    }
  
                    if (
                      obj !== false &&
                      obj.hasRunTimeDerivedComponents
                    ) {
                      setShowRuntimedrivecomponents(true);
                    } else {
                      setShowRuntimedrivecomponents(false);
                    }

                    if (
                      
                      obj !== false &&
                      obj.hasPTRTRATIO
                    ) {
                      setShowPTRTRATIO(true);
                    } else {
                      setShowPTRTRATIO(false);
                    }
                   }
                   
                  //end
                  if (
                    productsTotal[eq.equipment.nodeid] &&
                    eq.equipment.nodeid === props.activeEquipment
                  ) {
                    prod_total_count += productsTotal[eq.equipment.nodeid];
                  }
                  if (
                    rejectDetectionTotal[eq.equipment.nodeid] &&
                    eq.equipment.nodeid === props.activeEquipment
                  ) {
                    reject_total_count +=
                      rejectDetectionTotal[eq.equipment.nodeid];
                  }

                  if (
                    detectortest24h[eq.equipment.nodeid] &&
                    eq.equipment.nodeid === props.activeEquipment
                  ) {
                    detector_test_total_count +=
                      detectortest24h[eq.equipment.nodeid];
                  }
                }
              });
          }
        });
    });

    setProductTotalCount(prod_total_count);
    setRejectTotalCount(reject_total_count);
    setDetectorTestTotalCount(detector_test_total_count);

  }, [
    props.activeEquipment,
    getKpisData
  ]);

  return (
    <div>
      {" "}
      <>
        <div className="dashboard" style={{ marginTop: "2.5%" }}>
          <div className="header" style={{ marginTop: "50px", paddingLeft: 0 }}>
            <div className="title">{i18n(lang)?.statistics}</div>
          </div>
        </div>

        <div className="dashboardStatsWrapper">
          {props.showStatsExt === false ? (
            <div></div>
          ) : (
            <>
             {showPTRTRATIO===true ? (
              <DashboardStatistics
                text={i18n(lang)?.dashboard_proportion}
                stats={
                  <div className="__stats" style={{ color: "#6FA03B" }}>
                    {isNaN(rejectTotalCount / productTotalCount)
                      ? 0
                      : ((rejectTotalCount / productTotalCount) * 100).toFixed(
                          2
                        )}{" "}
                    <span style={{ fontSize: "20px" }}>%</span>
                  </div>
                }
              />
              ):(<></>)}
              {showPT===true ? (
                <DashboardStatistics
                  text={
                    <div>
                      {i18n(lang)?.product_count} <br></br>{" "}
                      
                    </div>
                  }
                  stats={
                    <div className="__stats" style={{ color: "#000000DE" }}>
                      {productTotalCount}
                    </div>
                  }
                />
              ) : (
                <></>
              )}

              {showRT ===true ? (
                <DashboardStatistics
                  text={
                    <div>
                      {i18n(lang)?.reject_detection} <br></br>{" "}
                      
                    </div>
                  }
                  stats={
                    <div className="__stats" style={{ color: "#000000DE" }}>
                      {rejectTotalCount}
                    </div>
                  }
                  
                />
              ) : (
                <></>
              )}
              {showDT ===true ? (
                <DashboardStatistics
                  text={
                    <div>
                      {i18n(lang)?.detector_test} <br></br>{" "}
                      
                    </div>
                  }
                  stats={
                    <div className="__stats" style={{ color: "#000000DE" }}>
                      {detectorTestTotalCount}
                    </div>
                  }
                 
                />
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </>
    </div>
  );
}

export default RenderKPI;
